<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnTertiary
 */
import type { BtnTertiaryProps } from '../types/interfaces'

import { IconContainer } from '@shared/ui/other'

defineOptions({
  name: 'BtnTertiary',
})

withDefaults(defineProps<BtnTertiaryProps>(), {
  title: '',
  color: 'gray',
  disabled: false,
})

const emit = defineEmits<{
  click: []
}>()

const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <button
    type="button"
    :class="['ui-btn-tertiary', color]"
    :title="title"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <span class="ui-btn-tertiary__text">
      {{ text }}
    </span>
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </button>
</template>

<style lang="scss" scoped src="../styles/_btn-tertiary.scss" />
